import { render, staticRenderFns } from "./FavouriteTogglerRow.vue?vue&type=template&id=f5bb4f66&"
import script from "./FavouriteTogglerRow.vue?vue&type=script&lang=js&"
export * from "./FavouriteTogglerRow.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteTogglerRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports